module App.Interfaces {
    export interface IReplacementVehicle {
        id: string;
        name: string;
        price: number;
        discountPrice: number;
        code: string;
        isAvailable: boolean;
        showPickupForm: boolean;
    }
}